import { Shadows } from '../../theme'

export default {
  pageBreakInside: 'avoid',
  boxShadow: `${Shadows.primaryShadow}, ${Shadows.secondaryShadow}`,
  overflow: 'inherit' // to combat some mui bs
}



// WEBPACK FOOTER //
// ./src/styles/cards/base.js